import React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Link from 'components/Link';
import modules from '../modulesConfig';
import useStyles from './style';
import { IReactProps } from 'types';

function ModulesNavigation({ className }: IReactProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classnames(className, classes.root)} data-testid="modules-navigation">
      {modules.map(({ name, path }) => (
        <Link
          className={classes.chip}
          component={NavLink}
          data-testid={`chip-${name}`}
          key={path}
          to={path}
        >
          <span data-testid="chip-label">{t(`title.${name}`)}</span>
        </Link>
      ))}
    </div>
  );
}

export default React.memo(ModulesNavigation);
